export default __webpack_public_path__ + "static/media/pencil.db438e4c.svg";